import { gql } from '@apollo/client'

export const GENERATE_DATA_VISUALIZATION = gql`
  mutation GenerateDataVisualization($naturalLanguageQuery: String!) {
    generateDataVisualization(naturalLanguageQuery: $naturalLanguageQuery) {
      sql
      data
      error
    }
  }
`